import { toast } from 'react-toastify';
import { Schemas } from '../models/entities';

import * as ActionTypes from './types';

const fetchPayments = (pageSize, pageNumber, sortBy, sortDesc, query) => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_PAYMENTS_REQUEST,
      ActionTypes.FETCH_PAYMENTS_SUCCESS,
      ActionTypes.FETCH_PAYMENTS_FAILURE,
    ],
    schema: Schemas.PAYMENT_ARRAY,
    endpoint: `/api/transactions?page=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy || ''}&sortDesc=${sortDesc}&search=${query ? encodeURI(query) : ''}`,
  },
});

const loadPayments = (query) => (dispatch, getState) => {
  const {
    pageSize = 10,
    pageNumber = 0,
  } = getState().pagination.payments || {};
  const {
    sortBy = 'id',
    sortDesc = false,
  } = getState().sorting.payments || {};
  return dispatch(fetchPayments(pageSize, pageNumber, sortBy, sortDesc, query))
    .catch((error) => toast.error(error.message));
};

export default loadPayments;
